import { z, type infer as zInfer } from "zod";

/**
 * Categories are maintained in the casino admin.
 */
export const casinoCategory = z.object({
  name: z.string(),
  iconUrl: z.string(),
  priority: z.number(),
  status: z.string(),
  slug: z.string().optional(),
});

export type CasinoCategory = zInfer<typeof casinoCategory> & { id: string };
